import React, {useEffect} from "react";
import UserManagerPage from "./userManager/UserManagerPage";
import {useQuery} from "@apollo/client";
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon,
    IonInput, IonItem,
    IonLabel, IonLoading, IonSpinner
} from "@ionic/react";
import moment from "moment";
import {
    gridOutline, gridSharp,
    keyOutline,
    keySharp,
    mailOutline,
    mailSharp,
    pencilOutline,
    pencilSharp, searchOutline, searchSharp,
    timerOutline,
    timerSharp
} from "ionicons/icons";
import {USER_GET_USER_QUERY, USERS_GET_QUERY} from "../schemas/userManager";
import {formatDatetime} from "../utils";




const UserManager: React.FC<any> = () => {


    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [userId, setUserId] = React.useState<number | undefined>(undefined);
    const [user, setUser] = React.useState<{id:number,name:string,email:string,status:number,details: string,visited:Date,registered:Date,color:string,user_roles:any, user_rules: any, rules_combined: any} | undefined | null>(null);
    const [rules, setRules] = React.useState<{name:string, roleId: number | undefined}[]>([]);
    const { loading, error, data } = useQuery(USERS_GET_QUERY, {variables: {}});
    const {loading:userLoading, error:userError, data: userData} = useQuery(USER_GET_USER_QUERY, {variables: {id:userId}, skip: !userId});

    const loadData = async () => {
        setUser(null);
    }

    useEffect(() => {
        loadData();
    },[data]);

    useEffect(() => {
        if (userData && userData.getUserData) {
            let rulesCombined: {name:string, roleId: number | undefined}[] = [];
            if (userData.getUserData && userData.getUserData.user_roles ) {
                rulesCombined = userData.getUserData.user_roles.flatMap((user_role:any) => {
                    return user_role.roles.role_rules.map((rule:any) => {
                        return {name: rule.rules.name, roleId:user_role.role_id};
                    });
                });
            }
            if (userData.getUserData && userData.getUserData.user_rules) {
                let ruleArr = userData.getUserData.user_rules.map((rule:any) => {
                    return {name: rule.rules.name};
                });
                rulesCombined = rulesCombined.concat(ruleArr);
            }
            setRules(rulesCombined);
            setUser(userData.getUserData);
        }
    }, [userData]);


    useEffect(() => {

    }, [user]);

    const loadUserData = async (id: number) => {
        if (userId === id || !id) {
            setUserId(undefined);
            setUser(null);
        } else {
            setUserId(id);
        }
    }

    return (
        <UserManagerPage page={'users'} style={{}}>
            <IonLoading isOpen={loading}></IonLoading>
            {!loading && data &&
                <div className="userManagerContent">
                    <IonButton size="small" color="light" routerLink={'/user-manager/create-user'} routerDirection="forward">
                        <IonLabel>+ Add User</IonLabel>
                    </IonButton>
                    <table style={{width: '100%', marginTop: '10px'}}>
                        <tbody>
                            <tr>
                                <td style={{verticalAlign: "top", width: !user && !userLoading ? '100%' : 'auto', padding: "0px"}}>
                                    <div style={{padding: '10px', background: 'white'}}>
                                        <table style={{width: '100%'}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:'90%'}}>
                                                        <IonItem>
                                                            <IonLabel>Search</IonLabel>
                                                            <IonInput> </IonInput>
                                                            <IonIcon slot="end" md={searchOutline} ios={searchSharp}></IonIcon>
                                                        </IonItem>
                                                    </td>
                                                    <td style={{textAlign:'right'}}>
                                                        <IonButton routerLink={'user-manager/grid-matrix'} routerDirection="none"><IonIcon md={gridOutline} ios={gridSharp}></IonIcon>&nbsp;Grid Matrix</IonButton>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        borderSpacing: '0px'
                                    }} className="striped">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Status</th>
                                            <th>Visited</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            data.allUsers && data.allUsers.map((user: any) => {
                                                    return (
                                                        <tr key={'user_' + user.id} onClick={() => loadUserData(user.id)}>
                                                            <td>
                                                                <div style={{
                                                                    marginRight: '20px',
                                                                    display: "inline-block",
                                                                    borderRadius: '20px',
                                                                    backgroundColor: user.color ? user.color : '#990099',
                                                                    color: 'white',
                                                                    lineHeight: '40px',
                                                                    height: '40px',
                                                                    width: '40px',
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'center'
                                                                }}>{user.name.substr(0, 1)}</div>
                                                                {user.name}
                                                            </td>
                                                            <td style={{
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px',
                                                                paddingLeft: '5px',
                                                                paddingRight: '5px'
                                                            }}>{user.email}</td>
                                                            <td style={{
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px',
                                                                paddingLeft: '5px',
                                                                paddingRight: '5px',
                                                                textAlign: 'center'
                                                            }}>{user.status === 1 &&
                                                                <div className={'badge success'}>Active</div>}{!user.status &&
                                                                <div className={'badge danger'}>Inactive</div>}</td>
                                                            <td style={{
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px',
                                                                paddingLeft: '5px',
                                                                paddingRight: '5px'
                                                            }}>{moment(user.visited).format('M/d/y hh:mm:ss')}</td>

                                                        </tr>
                                                    );
                                                }
                                            )
                                        }
                                        </tbody>
                                    </table>
                                </td>
                                <td style={{width: '10px', padding: '0px'}}></td>
                                <td style={{verticalAlign: "top", width: !user && !userLoading ? '0px' : '350px', padding: '0px'}}>
                                    {userLoading && userId &&
                                        <IonCard style={{
                                            display: 'inline-block',
                                            verticalAlign: 'top',
                                            margin: '0px',
                                            width: '100%', top:'0px', position: 'sticky'
                                        }}>
                                            <IonCardContent>
                                                <div style={{position: 'relative', width: '100%', height: '100%', lineHeight: '100%', verticalAlign: 'middle'}}>
                                                    <IonSpinner style={{position: 'sticky', left: '50%', top: '50%'}}></IonSpinner>
                                                </div>
                                            </IonCardContent>
                                        </IonCard>
                                    }
                                    {user && !userLoading &&
                                        <IonCard style={{
                                            display: 'inline-block',
                                            verticalAlign: 'top',
                                            margin: '0px',
                                            width: '100%', top:'0px', position: 'sticky'
                                        }}>
                                            <IonCardHeader style={{borderBottom: '1px solid #cccccc'}}>

                                                <IonCardTitle style={{float: 'left'}}>{user.name}</IonCardTitle>

                                                <div style={{
                                                    display: 'inline-block',
                                                    verticalAlign: 'top',
                                                    float: 'right'
                                                }}>
                                                    <IonButton fill="clear" size="small" href={"/user-manager/edit-user/" + user.id}><IonIcon md={pencilOutline} ios={pencilSharp}></IonIcon></IonButton>
                                                </div>
                                                <div style={{clear: "both"}}></div>
                                            </IonCardHeader>
                                            <IonCardContent style={{padding:'10px'}}>

                                                <table style={{width: '100%'}}>
                                                    <tbody>
                                                    <tr>
                                                        <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                            <b><IonIcon md={mailOutline} ios={mailSharp}></IonIcon></b>
                                                        </td>
                                                        <td><b>Email:</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {user.email}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                            <b><IonIcon md={timerOutline} ios={timerSharp}></IonIcon></b>
                                                        </td>
                                                        <td><b>Visited:</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {formatDatetime(user.visited)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                            <b><IonIcon md={keyOutline} ios={keySharp}></IonIcon></b>
                                                        </td>
                                                        <td><b>Roles:</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {user.user_roles && user.user_roles.map((userRole: any) => {
                                                                return (<div key={'role_' + userRole.id}>
                                                                    {userRole.roles.name}<br/>
                                                                </div>)
                                                            })
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                            <b><IonIcon md={keyOutline} ios={keySharp}></IonIcon></b>
                                                        </td>
                                                        <td><b>Rules:</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {rules && rules.filter((value, index, self) =>
                                                                    // filter to unique rule names
                                                                    index === self.findIndex((t) => (
                                                                        t.name === value.name
                                                                    ))
                                                            ).map((userRule: any) => {
                                                                return (<div key={'rules_' + userRule.name}>
                                                                    {userRule.name}<br/>
                                                                </div>)
                                                            })
                                                            }
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                            </IonCardContent>

                                        </IonCard>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            }
        </UserManagerPage>
    );
};


export default UserManager;